<template>
  <div class="AccountMenuList">
    <ul
      v-for="(items, index) in sections"
      :key="index"
    >
      <NavigationEntry
        v-for="item in items"
        :key="item.name"
        :item="item"
        @click="run(item)"
      />
    </ul>
  </div>
</template>

<script src="./account_menu_list.js"></script>

<style lang="scss">
.AccountMenuList {
  ul {
    list-style: none;
    margin: 0;
    padding: 0.25em;
  }

  ul + ul {
    border-top: 1px solid var(--border);
  }

  .menu-item {
    border-radius: var(--r-item);
  }
}
</style>
